var React = require('react');

function Profile1 (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .st0 {\n        fill: #0555c8;\n      }\n\n      .st1, .st2 {\n        fill: none;\n        stroke: #0555c8;\n        stroke-miterlimit: 10;\n        stroke-width: 2.5px;\n      }\n\n      .st2 {\n        stroke-linecap: round;\n      }\n\n      .st3 {\n        display: none;\n      }\n    ")),React.createElement("g",{"id":"Layer_2","key":1},[React.createElement("circle",{"className":"st1","cx":"32","cy":"22.7","r":"12.2","key":0}),React.createElement("path",{"className":"st2","d":"M10.6,53.5s0-12.3,11.4-12.3h19.4s11.8-.2,11.8,12.3","key":1})])]);
}

Profile1.defaultProps = {"version":"1.1","viewBox":"0 0 64 64"};

module.exports = Profile1;

Profile1.default = Profile1;
